export default __webpack_public_path__ + "static/media/home.5c6ce74d.png";